export enum EventKey {
  SidesheetEntityDeleted = 'SidesheetEntityDeleted',
  RouteNetworkRefetchTriggered = 'RouteNetworkRefetchTriggered',
}
